import React, { useState } from "react";

/**
 * CCRosterBar —— 研讨角色名册条（认知协同）。
 *
 * 展示本次实验可参与研讨的子智能体（导师/专家/干系人等），让学生一眼看到
 * "有哪些人可以一起想问题"。默认折叠为一行，可展开看每个角色的职责说明。
 *
 * props.roster = [{ name, description, role }]
 */
const ROLE_META = {
  mentor:      { icon: "🧭", color: "#d29922" },
  expert:      { icon: "🔬", color: "#58a6ff" },
  stakeholder: { icon: "🧑‍💼", color: "#a371f7" },
  compliance:  { icon: "🛡️", color: "#f0883e" },
};
const DEFAULT_META = { icon: "🤝", color: "#3fb950" };

const prettyName = (name) =>
  (name || "")
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const CCRosterBar = ({ roster }) => {
  const [open, setOpen] = useState(false);
  if (!roster || roster.length === 0) return null;

  return (
    <div
      style={{
        flexShrink: 0,
        borderBottom: "1px solid #21262d",
        background: "#0b0f16",
        padding: "5px 12px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
        <span style={{ fontSize: "11px", color: "#8b949e", flexShrink: 0 }}>🧠 认知协同团队</span>
        <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", flex: 1, minWidth: 0 }}>
          {roster.map((r) => {
            const meta = ROLE_META[r.role] || DEFAULT_META;
            return (
              <span
                key={r.name}
                title={r.description || r.name}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                  fontSize: "11px",
                  color: "#c9d1d9",
                  background: `${meta.color}18`,
                  border: `1px solid ${meta.color}44`,
                  borderRadius: "12px",
                  padding: "1px 9px",
                }}
              >
                <span>{meta.icon}</span>
                {prettyName(r.name)}
              </span>
            );
          })}
        </div>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          style={{
            flexShrink: 0,
            background: "none",
            border: "none",
            color: "#58a6ff",
            fontSize: "11px",
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          {open ? "收起职责 ▲" : "查看职责 ▼"}
        </button>
      </div>

      {open && (
        <div style={{ marginTop: "6px", display: "flex", flexDirection: "column", gap: "4px" }}>
          {roster.map((r) => {
            const meta = ROLE_META[r.role] || DEFAULT_META;
            return (
              <div key={`d-${r.name}`} style={{ display: "flex", gap: "6px", fontSize: "11px", lineHeight: 1.5 }}>
                <span style={{ flexShrink: 0 }}>{meta.icon}</span>
                <span style={{ color: meta.color, fontWeight: 600, flexShrink: 0 }}>{prettyName(r.name)}</span>
                <span style={{ color: "#8b949e", minWidth: 0 }}>{r.description || "（暂无职责说明）"}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CCRosterBar;
